import { render } from "./tipologiaForm.vue?vue&type=template&id=70ac5d5a&scoped=true"
import script from "./tipologiaForm.vue?vue&type=script&lang=js"
export * from "./tipologiaForm.vue?vue&type=script&lang=js"

import "./tipologiaForm.vue?vue&type=style&index=0&id=70ac5d5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ac5d5a"]])

export default __exports__